// removed by extract-text-webpack-plugin
module.exports = {"textPage__start_slider":"textPage__start_slider__2EiL3","content":"content__2swqW"};


//////////////////
// WEBPACK FOOTER
// ./components/TextPage/TextPage.scss
// module id = bNk3
// module chunks = 0